/**
 * Validates that a redirect URL is safe (relative path, no protocol-relative URLs).
 * Blocks //evil.com and other open redirect vectors.
 */
export function isSafeRedirect(url: string | null | undefined): url is string {
  return typeof url === "string" && url.startsWith("/") && !url.startsWith("//")
    && !/[\\\u0000-\u0020\u007f]/.test(url);
}
